<script lang="ts">
	export let clickable = false;
	export let selected = false;
	export let href: string | undefined = undefined;
	export let express = false;
</script>

{#if href}
	<a
		{href}
		class="text-3xs md:text-2xs rounded-full border px-3 font-normal leading-5 {express && !selected
			? 'bg-express !border-express text-white'
			: 'text-secondary bg-white'}"
		class:border-primary={selected}
		class:!text-primary={selected && !express}
	>
		<slot />
	</a>
{:else}
	<button
		class="text-3xs md:text-2xs text-secondary rounded-full border bg-white px-3 font-normal leading-5"
		class:border-primary={selected}
		class:!text-primary={selected && !express}
		class:pointer-events-none={!clickable}
		class:bg-express={express}
		on:click
	>
		<slot />
	</button>
{/if}
